import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSnackbarSuccess, MandatoryStar } from "../../Utils/helper";
import {
  BillingAdjustmentAction,
  EditByFinanceAction,
  GetInsurerPayoutCountsNetwork,
  GetTotalAppointmentAction,
  GSTCalculation,
} from "../../redux/actions/InsBillAction";

export const EditByFinance = ({
  searchFilter,
  setOpenModel,
  providerDetail,
  setProviderDetail,
  openModel,
}) => {
  const ref = useRef();
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const [payload, setPayload] = useState({
    clientId: null,
    remarks: "",
    insurerSum: null,
    homeVisitSum: null,
    serviceCharges: null,
    gst: null,
  });
  const insBillReducer = useSelector(
    (state) => state?.InsBillingPayout?.insRemarks
  );

  useEffect(() => {

    const debounceTimer = setTimeout(() => {
      const res = dispatch(
        GSTCalculation({
          appointmentId: providerDetail[0]?.appointmentId,
          insurerSum: payload?.insurerSum,
          homeVisitSum: payload?.homeVisitSum,
          serviceCharges: payload?.serviceCharges,
        })
      )
      .then((res)=>{
        setPayload({...payload,gst:res?.data?.results})
      })
      setDebouncedValue(inputValue);
    }, 500); // Debounce time: 500 milliseconds

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [payload?.insurerSum, payload?.homeVisitSum, payload?.serviceCharges]);

  useEffect(() => {
    const rem = insBillReducer?.filter((ele) => {
      if (
        ele?.appointmentId === providerDetail[0]?.appointmentId &&
        ele?.remarksType === "Edit"
      ) {
        return ele;
      }
    });
    setPayload({
      clientId: providerDetail[0]?.clientId,
      remarks: rem[0]?.remarks,
      insurerSum: providerDetail[0]?.insurerSum,
      homeVisitSum: providerDetail[0]?.homeVisitSum,
      serviceCharges: providerDetail[0]?.serviceCharges,
      gst: providerDetail[0]?.gst,
    });
  }, [providerDetail]);

  const dispatch = useDispatch();
  const handleSubmit = async (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    if (event.target.checkValidity()) {
      const res = await dispatch(
        EditByFinanceAction({
          appointmentId: providerDetail[0]?.appointmentId,
          clientId: providerDetail[0]?.clientId,
          ...payload,
        })
      );
      if (res) {
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        setTimeout(()=>{
          dispatch(
            GetTotalAppointmentAction({
              ...searchFilter,
              page: 1,
              rows: 10,
              IsPayoutStatus: true,
            })
          );
          dispatch(GetInsurerPayoutCountsNetwork(searchFilter))
        },20000)
        handleClose();
      }
    }
  };

  const handleClose = () => {
    setOpenModel({ ...openModel, editByFin: false });
    setProviderDetail([]);
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black ">Finance Update</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose()}
        ></button>
      </div>

      <form
        ref={ref}
        className="form-admin"
        style={{ overflowX: "hidden" }}
        onSubmit={handleSubmit}
        noValidate
      >
        <div className="modal-body ">
          <div className="row ">
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">Case Number</label>
              <input
                name="caseNo"
                type="text"
                disabled={true}
                value={providerDetail[0]?.caseNo}
                placeholder="Enter Here..."
                className="form-control form-select-admin inputbgavanish"
                // required
                // onChange={(e) => handleChange("caseNo", e.target.value)}
              />
            </div>

            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">
                Insurer Sum
                <MandatoryStar />
              </label>
              <input
                name="providerAmount"
                type="number"
                placeholder="Enter Here..."
                value={payload?.insurerSum}
                onKeyPress={(e) => {
                  const value = e.target.value;
                  const allowedChars = /^[0-9\b.]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }

                  // Check if the input already contains a decimal point
                  if (e.key === "." && value.includes(".")) {
                    e.preventDefault();
                  }

                  // Check if the input is going to exceed two decimal places
                  if (
                    value.includes(".") &&
                    value.split(".")[1].length >= 2 &&
                    e.key !== "Backspace"
                  ) {
                    e.preventDefault();
                  }
                }}
                min={1}
                className="form-control form-select-admin inputbgavanish"
                required
                onChange={(e) => {
                  setPayload({ ...payload, insurerSum: e.target.value });
                }}
              />
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">
                Home Visit Charges
              </label>
              <input
                name="providerAmount"
                type="number"
                placeholder="Enter Here..."
                value={payload?.homeVisitSum}
                onKeyPress={(e) => {
                  const value = e.target.value;
                  const allowedChars = /^[0-9\b.]+$/;
                  if (!allowedChars.test(e.key)) {
                    e.preventDefault();
                  }

                  // Check if the input already contains a decimal point
                  if (e.key === "." && value.includes(".")) {
                    e.preventDefault();
                  }

                  // Check if the input is going to exceed two decimal places
                  if (
                    value.includes(".") &&
                    value.split(".")[1].length >= 2 &&
                    e.key !== "Backspace"
                  ) {
                    e.preventDefault();
                  }
                }}
                // min={1}
                className="form-control form-select-admin inputbgavanish"
                // required
                onChange={(e) => {
                  setPayload({ ...payload, homeVisitSum: e.target.value });
                }}
              />
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">
                Service Charges
              </label>
              <input
                name="providerAmount"
                type="text"
                disabled={true}
                placeholder="Enter Here..."
                value={payload?.serviceCharges}
                className="form-control form-select-admin inputbgavanish"
              
              />
            </div>
            <div className="col-lg- 6 col-md-6">
              <label className="col-form-label">
                GST
              </label>
              <input
                name="providerAmount"
                type="text"
                disabled={true}
                placeholder="Enter Here..."
                value={payload?.gst}
                className="form-control form-select-admin inputbgavanish"
              />
            </div>
            <div className="col-lg-6 col-md-6 ">
              <label className="col-form-label">
                Remarks
                <MandatoryStar />
              </label>
              <input
                className="form-control form-select-admin inputbgavanish"
                // rows="5"
                // cols="33"
                required
                value={payload?.remarks}
                onKeyPress={(e) => {
                  const re = /^[a-zA-Z\s]*$/;
                  if (e.target.value.trim() === "" && e.key === " ") {
                    e.preventDefault();
                    return;
                  }
                }}
                onChange={(e) =>
                  setPayload({ ...payload, remarks: e.target.value })
                }
              />
            </div>
          </div>
        </div>

        <div className="modal-footer modal-footer-admin  bottom-0  mt-4">
          <div className="d-flex justify-content-end flex-wrap gap-10">
            <button
              onClick={() => handleClose()}
              type="btn"
              className="savedetails"
            >
              Cancel
            </button>
            <button type="submit" className="savedetails">
              {"Update"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
